// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__sYxPt","footerColumn":"Footer_footerColumn__3irC-","socialIcons":"Footer_socialIcons__X5okp","socialIcon":"Footer_socialIcon__+lffM"};